import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { I18nextProvider } from "react-i18next";
import language from "shared/helpers/language";
import { RecoilRoot } from "recoil";
import { QueryClientProvider, QueryClient } from "react-query";
import { AuthProvider } from "shared/context/auth-context";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <AuthProvider>
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={language}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </I18nextProvider>
      </QueryClientProvider>
    </RecoilRoot>
  </AuthProvider>
);
